import(/* webpackMode: "eager" */ "/root/repo/src/app/dashboard/page.tsx");
